module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Infographic.65b01bfb.png";